/*
 * A service to deal with the configuration parameters
 * <p>
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2020 Gallagher Bassett Services, Inc.
 *
 */

import { Injectable } from '@angular/core';
import { Constants } from 'app/shared/config/constants';
import { HttpClient } from '@angular/common/http';
import { registerLicense } from '@syncfusion/ej2-base';

@Injectable ( {
  providedIn: 'root',
} )
export class ConfigurationService {

  private readonly configUrl = Constants.configurationServiceUrl;
  private config: any;

  constructor ( private http: HttpClient ) {
    this.config = JSON.parse ( localStorage.getItem ( 'reporterConfig' ) );
  }

  get configuration () {
    return this.config;
  }

  set configuration ( config ) {
    this.config = [ ...config ];
    localStorage.setItem ( 'reporterConfig', JSON.stringify ( this.config ) );
  }

  byKey ( key: string ) {
    const result = this.config?.find ( c => c.key === key );
    return result?.value;
  }

  get mfaNoticeEnabled (): boolean {
    return this.byKey ( Constants.mfaNoticeEnabledConfigKey ) === 'true';
  }

  loadConfiguration () {
    return this.http.get<any[]> ( Constants.configurationUri )
      .toPromise ()
      .then ( configuration => {
        this.configuration = configuration;
        this.applySyncfusionLicense ();
      } );
  }

  private applySyncfusionLicense (): void {
    const licenseKey = this.byKey ( 'syncfusion.license.key' );
    if ( licenseKey ) {
      registerLicense ( licenseKey );
    }
  }
}
